export const indexCopy = {
  index_2_headline:
    "TypeScript is <bold>JavaScript with syntax for types.</bold>",
  index_2_byline: "TypeScript extends JavaScript by adding types.",
  index_2_summary:
    "TypeScript is a strongly typed programming language that builds on JavaScript, giving you better tooling at any scale.",

  // Above the fold
  index_2_cta_install: "Try TypeScript Now",
  index_2_cta_install_subtitle: "Online or via npm",

  index_2_cta_play: "In your browser",
  index_2_cta_play_subtitle: "via the Playground",

  index_2_cta_download: "On your computer",
  index_2_cta_download_subtitle: "via npm",

  // Editor titles
  index_2_tab_1: "Editor Checks",
  index_2_tab_2: "Auto-complete",
  index_2_tab_3: "Interfaces",
  index_2_tab_4: "JSX",
  index_2_tab_5: "ESNext",

  // Quick pitch
  index_2_what_is: "What is TypeScript?",
  index_2_what_is_js: "JavaScript and More",

  index_2_what_is_js_copy: `TypeScript adds additional syntax to JavaScript to support a <strong>tighter integration with your editor</strong>. Catch errors early in your editor.`,
  index_2_trust: "A Result You Can Trust",
  index_2_trust_copy: `TypeScript code converts to JavaScript, which <strong>runs anywhere JavaScript runs</strong>: In a browser, on Node.js, Deno, Bun and in your apps.`,
  index_2_scale: "Safety at Scale",
  index_2_scale_copy: `TypeScript understands JavaScript and uses <strong>type inference to give you great tooling</strong> without additional code.`,

  // Links for getting started (this shows up twice)
  index_2_started_title: "Get Started",
  index_2_started_handbook: "Handbook",
  index_2_started_handbook_blurb: "Learn the language",
  index_2_install: "Install TypeScript",
  index_2_playground_blurb: "Try in your browser",

  index_2_migrate_1: "JavaScript file",
  index_2_migrate_2: "JavaScript with TS Check",
  index_2_migrate_3: "JavaScript with JSDoc",
  index_2_migrate_4: "TypeScript file",

  // Stories + OSS users`
  index_2_migration_title: "TypeScript Testimonials",
  index_2_migration_oss: "Open Source with TypeScript",

  // Survey results
  index_2_loved_by: "Loved by Developers",
  index_2_loved_stack: `Voted <strong>2nd most loved programming language</strong> in the <so>Stack Overflow 2020 Developer survey</so>`,
  index_2_loved_state_js: `TypeScript was <strong>used by 78%</strong> of the <js>2020 State of JS</js> respondents, with <strong>93% saying they would use it again</strong>.`,
  index_2_loved_state_js2: `TypeScript was given the award for <strong>“Most Adopted Technology”</strong> based on year-on-year growth.`,

  // Show me some code
  index_2_describe: "Describe Your Data",
  index_2_describe_blurb1:
    "<strong>Describe the shape of objects and functions</strong> in your code.",
  index_2_describe_blurb2:
    "Making it possible to see <strong>documentation and issues in your editor</strong>.",

  // Show how tsc 'works'
  index_2_transform: "TypeScript becomes JavaScript via the delete key.",
  index_2_transform_1: "<strong>TypeScript file</strong>.",
  index_2_transform_2: "<strong>Types are removed</strong>.",
  index_2_transform_3: "<strong>JavaScript file</strong>.",

  // Adopt TS gradually animations
  index_2_adopt: "Adopt TypeScript Gradually",
  index_2_adopt_blurb_1:
    "Apply types to your JavaScript project incrementally, <strong>each step improves editor support</strong> and improves your codebase.",
  index_2_adopt_blurb_2:
    "Let's take this incorrect JavaScript code, and see how <strong>TypeScript can catch mistakes in your editor</strong>.",

  index_2_adopt_info_1:
    "No editor warnings in JavaScript files.<br/><br/>This crashes at runtime.",
}
